module.exports = "https://static.energy5.com/_next/static/images/solarBg-e285966dec264caabe1e3b31eb9869ed.webp";